export default __webpack_public_path__ + "images/71770a26e250ab0d0f51d996474fa206-community.jpg";